import { COMPONENTS, EVENTS, ErrorTypes } from "../../lib/constants";
import { GameConfigs } from "../../lib/globals/GameConfigs";
import HELPERS from "../../lib/globals/helpers/Helpers";
import { NotificationView } from "../../view/notifications/NotificationView";
import removeViews from "./removeViews";
import ErrorPage from "../../Error";

export default function handleError(msg, app) {
  if (msg.code) {
    HELPERS.dispatchCustomEvent(EVENTS.ERROR_MSG, msg);
    if (
      GameConfigs.uiComponent &&
      GameConfigs.uiComponent[COMPONENTS.FREESPIN_STATUS_BAR]
    ) {
      GameConfigs.uiComponent.removeView(
        GameConfigs.uiComponent[COMPONENTS.FREESPIN_STATUS_BAR]
      );
      HELPERS.disableAllButtons(false);
      HELPERS.dispatchCustomEvent(EVENTS.FREESPIN, {
        freespin: {
          ...GameConfigs.freeSpinLocal,
          show: false,
          started: false,
        },
      });
      GameConfigs.freeSpinLocal = {
        ...GameConfigs.freeSpinLocal,
        show: false,
        started: false,
      };
    }
    switch (msg.code) {
      case +ErrorTypes.DISCONNECT:
      case +ErrorTypes.GENERAL_ERROR:
      case +ErrorTypes.SESSION_CLOSED:
      case +ErrorTypes.CONCURRENT_CONNECTION:
      case +ErrorTypes.INVALID_SESSION:
      case +ErrorTypes.INVALID_MESSAGE:
        HELPERS.dispatchCustomEvent(EVENTS.ERROR_PAGE, { error: true });
        GameConfigs.errors = msg;
        if (app.errorPage === null) {
          app.game && removeViews(app.game);
          app.errorPage = new ErrorPage();
          GameConfigs.Pixi.stage.addChild(app.errorPage);
          GameConfigs.App.resized();
        }
        if (GameConfigs.uiComponent) {
          GameConfigs.uiComponent.alpha = 1;
        }
        app.setState({ loaded: true });
        break;
      case +ErrorTypes.INVALID_TRANSFER:
      case +ErrorTypes.INVALID_SERVICE:
      case +ErrorTypes.INVALID_BET_AMOUNT:
      case +ErrorTypes.INSUFFICIENT_FUNDS:
      case +ErrorTypes.INVALID_BET:
      case +ErrorTypes.MAX_BET_LIMIT:
      case +ErrorTypes.BET_TIMEOUT:
      case +ErrorTypes.FREESPIN_ERROR:
      case +ErrorTypes.FREESPIN_EXPIRED:
        GameConfigs.win = 0;
        if (GameConfigs.modal !== "notification") {
          GameConfigs.modal = "notification";
          GameConfigs.notification = msg;

          if (GameConfigs.uiComponent[COMPONENTS.NOTIFICATION] === undefined) {
            HELPERS.dispatchCustomEvent(EVENTS.MODAL, {
              modal: "notification",
            });
            GameConfigs.uiComponent.addView(NotificationView);
          }

          if (GameConfigs.bonusBuy) {
            GameConfigs.bonusBuy = false;
            HELPERS.dispatchCustomEvent(EVENTS.BONUS_BUY, { bonus: false });
          }
          if (GameConfigs.quest_is_active) {
            GameConfigs.quest_is_active = false;
          }
          if (GameConfigs.isFreeSpin) {
            GameConfigs.isFreeSpin = false;
          }
          if (GameConfigs.uiComponent[COMPONENTS.QUEST_STATUS_BAR]) {
            GameConfigs.uiComponent.removeView(
              GameConfigs.uiComponent[COMPONENTS.QUEST_STATUS_BAR]
            );
          }
          if (GameConfigs.uiComponent[COMPONENTS.FREESPIN_STATUS_BAR]) {
            GameConfigs.uiComponent.removeView(
              GameConfigs.uiComponent[COMPONENTS.FREESPIN_STATUS_BAR]
            );
          }
        }
        break;
      default:
        break;
    }
  }
}
